// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export function getValidateAlphanumericMessage(value: string): string {
  if (value && !/^[a-zA-Z0-9]+$/.test(value)) {
    return 'Must contain only alphanumeric characters';
  }
  return '';
}

export function getValidateVisibleMessage(value: string): string {
  if (value && !/[\p{Letter}\p{Number}\p{Symbol}]/u.test(value)) {
    return 'Must contain a visible character';
  }
  return '';
}
